<template>
    <div class="carousel__wrapper">
        <Carousel v-bind="config">
            <Slide v-for="(anexo, idAnexo) in anexos" :key="idAnexo">
                <a :href="anexo.url" class="w-100 h-100" target="_blank">
                    <div class="imagem-anexo w-100 h-100 borda-redonda sombra" v-bind:style="{ backgroundImage: `url(${anexo.url})` }" v-if="verificaImagem(anexo.url)"></div>
                    <i v-else class="far fa-file fa-5x"></i>
                </a>
            </Slide>

            <template #addons>
                <Navigation />
            </template>
        </Carousel>
    </div>
</template>

<script setup>
import 'vue3-carousel/carousel.css';
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import { defineProps } from 'vue';

defineProps({
    anexos: {
        type: Array,
        default: () => []
    }
});

const config = {
    height: 200,
    itemsToShow: 1,
    gap: 5,
    snapAlign: 'center',
    breakpointMode: 'carousel',
    breakpoints: {
        300: {
            itemsToShow: 2,
            snapAlign: 'center',
        },
        400: {
            itemsToShow: 3,
            snapAlign: 'start',
        },
        500: {
            itemsToShow: 4,
            snapAlign: 'start',
        },
    },
};

function verificaImagem(urlArquivo) {
    const ext = urlArquivo.split('.').pop();
    return (['jpg', 'jpeg', 'png', 'jfif', 'bmp', 'gif'].indexOf(ext) > -1);
}

</script>

<style>
img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.carousel__wrapper {
    overflow: auto;
    max-width: 688px;
    padding: 0;
}
.carousel__viewport {
    width: 85%;
    margin: 0 auto;
}
.item-anexo {
    height: 150px !important;
    width: 90px !important;
    padding: 0.5rem !important;
}
.imagem-anexo{
    background-size: cover;
    background-position: center
}
</style>